import type { PremiumInvitePublicConfig } from "./premiumInvitePublicConfig";

/**
 * IDs preset cuando el admin eligió lista curada (sin llamar a `/api/mux-videos`).
 */
export function getReelsPlaybackIdsPreset(
  cfg: PremiumInvitePublicConfig | null | undefined,
): string[] | undefined {
  if (cfg?.reels_playback_source !== "curated") return undefined;
  const ids = cfg.reels_curated_playback_ids;
  return ids?.length ? ids : undefined;
}
